import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { VStack } from '../../../components/primitives';
import { ProgressBar } from '../../../components/primitives/ProgressBar';
import { Text } from '../../../components/primitives/Text';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import { tokens } from '../../../theme/tokens';

interface ImportProgressCardProps {
  totalRows: number;
  isPending: boolean;
}

export function ImportProgressCard({ totalRows, isPending }: Readonly<ImportProgressCardProps>) {
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      <VStack spacing="lg" align="center">
        <ActivityIndicator size="large" color={colors.primary[500]} />
        <VStack spacing="sm" align="center" style={styles.textContainer}>
          <Text variant="h5" color={colors.text.primary}>
            {t('leadImport.progress.title')}
          </Text>
          <Text variant="body" color={colors.text.tertiary}>
            {t('leadImport.progress.processing', { n: totalRows })}
          </Text>
        </VStack>
        <View style={styles.progressContainer}>
          <ProgressBar value={isPending ? 50 : 100} gradient animated height={8} />
        </View>
        <Text variant="caption" color={colors.text.tertiary}>
          {t('leadImport.progress.doNotClose')}
        </Text>
      </VStack>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: tokens.spacing.xl,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200,
  },
  textContainer: {
    width: '100%',
  },
  progressContainer: {
    width: '100%',
    paddingHorizontal: tokens.spacing.xl,
  },
});
